import {useRef, useCallback} from "react";
import {PhotoProvider, PhotoView} from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import Button from "../../../basics/button/Button";

const FileImageShow = ({
    file: {FileName, Name},
    url,
    onLoadFile,
    onCloseClick,
    buttonPrevious,
    buttonNext,
}) => {
    const triggerRef = useRef(null);
    const handleClick = useCallback(
        (e) => {
            const mask = document.querySelector(".PhotoView__PhotoWrap");
            const photo = document.querySelector(".PhotoView__Photo");

            if (
                mask &&
                photo &&
                mask.contains(e.target) &&
                !photo.contains(e.target)
            ) {
                onCloseClick?.();
            }
        },
        [onCloseClick]
    );

    const handleImageLoad = () => {
        onLoadFile?.();
        setTimeout(() => {
            triggerRef.current?.click();
            document.addEventListener("click", handleClick, true);
        }, 0);
    };

    const handleVisibleChange = useCallback(
        (visible) => {
            if (!visible) {
                onCloseClick?.();
                document.removeEventListener("click", handleClick, true);
            } else {
                const name = FileName || Name || "";
                setTimeout(() => {
                    const counter = document.querySelector(
                        ".PhotoView-Slider__Counter"
                    );
                    if (counter && !counter.innerText.includes(name)) {
                        counter.innerText = `${name}`;
                    }
                }, 50);
            }
        },
        [onCloseClick, FileName, Name, handleClick]
    );

    if (!url) return null;

    return (
        <div className="file-image-show">
            <div className="button-container">
                <Button
                    onClick={buttonPrevious}
                    buttonStyle={"text"}
                    className="file-show-button previous">
                    <i className="fas fa-chevron-left" />
                </Button>
                <Button
                    onClick={buttonNext}
                    buttonStyle={"text"}
                    className="file-show-button next">
                    <i className="fas fa-chevron-right" />
                </Button>
            </div>
            <PhotoProvider
                maskOpacity={0.8}
                maskClosable={false}
                onVisibleChange={handleVisibleChange}>
                <PhotoView src={url}>
                    <img
                        data-testid="image-element"
                        ref={triggerRef}
                        src={url}
                        alt={FileName}
                        draggable={false}
                        onLoad={handleImageLoad}
                        style={{
                            display: "none", // ukrywamy miniaturkę
                        }}
                    />
                </PhotoView>
            </PhotoProvider>
        </div>
    );
};

export default FileImageShow;
